import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Profile } from 'types/auth';

interface UserState {
  userInfo: Profile | null;
}

const initialState: UserState = {
  userInfo: null
};

const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUserInfo(state, action: PayloadAction<Profile>) {
      state.userInfo = { ...action.payload };
    }
  }
});

export default user.reducer;

export const { setCurrentUserInfo } = user.actions;

export const getUser = (state: { user: UserState }) => state.user.userInfo;
